export default __webpack_public_path__ + "static/media/flash-light.f4b3d846.svg";